import React, { useRef } from 'react';
import { useUnistyles } from 'react-native-unistyles';
import { saveStorageBlob } from '@/utils/FileManager';
import { getCurrentOrgID } from '@/data/organization';
import * as Crypto from 'expo-crypto';

const ImageBlock = ({ block, isSelected, onSelect, onUpdate }) => {
    const { theme: { colors, fonts } } = useUnistyles();
    const { content, styles: blockStyles } = block;
    const inputRef = useRef(null);

    const handleUpload = async (file) => {
        if (!file) return;
        try {
            const orgID = await getCurrentOrgID();
            const ext = file.name.split('.').pop() || 'jpg';
            const key = `org_pub_files/${orgID}/email_images/${Crypto.randomUUID()}.${ext}`;
            const result = await saveStorageBlob(file, key, true);
            if (result && result.storageUrl) {
                onUpdate(block.id, { ...block.content, src: result.storageUrl });
            }
        } catch (e) {
            console.error('Image upload failed', e);
        }
    };

    const padding = `${blockStyles.paddingTop ?? 10}px ${blockStyles.paddingRight ?? 20}px ${blockStyles.paddingBottom ?? 10}px ${blockStyles.paddingLeft ?? 20}px`;

    return (
        <div
            onClick={(e) => { e.stopPropagation(); onSelect(block.id); }}
            style={{
                padding,
                backgroundColor: blockStyles.backgroundColor || 'transparent',
                textAlign: blockStyles.textAlign || 'center',
                outline: isSelected ? `2px solid ${colors.primary}` : '2px solid transparent',
                outlineOffset: '-2px',
                cursor: 'pointer',
            }}
        >
            {content.src ? (
                <img
                    src={content.src}
                    alt={content.alt || ''}
                    style={{
                        display: 'block',
                        maxWidth: content.width || '100%',
                        height: 'auto',
                        margin: blockStyles.textAlign === 'left' ? '0' : blockStyles.textAlign === 'right' ? '0 0 0 auto' : '0 auto',
                    }}
                />
            ) : (
                <div
                    style={{
                        backgroundColor: '#f3f4f6',
                        border: '1px dashed rgba(0,0,0,0.15)',
                        borderRadius: 8,
                        padding: '32px 20px',
                        textAlign: 'center',
                        cursor: 'pointer',
                    }}
                    onClick={(e) => { e.stopPropagation(); inputRef.current?.click(); }}
                >
                    <div style={{ fontSize: 13, color: colors.textTertiary, marginBottom: 8, fontFamily: fonts.body }}>Click to upload image</div>
                    <div style={{ fontSize: 11, color: colors.textTertiary, fontFamily: fonts.body }}>PNG, JPG, GIF, WEBP</div>
                </div>
            )}
            <input
                ref={inputRef}
                type="file"
                accept="image/*"
                style={{ display: 'none' }}
                onChange={(e) => handleUpload(e.target.files?.[0])}
            />
        </div>
    );
};

export default ImageBlock;
